(function () {
	'use strict';
	angular.module('GorillaBoy.build')
	.constant('SourceConstant', {
		FILES: "assets/"
	})
	.constant('MSIE', {
		// Based on regex from AngularJS. We can detect version for anything prior to IE11 using this regex
		VERSION: function () {
			return (/msie (\d+)/i.exec(navigator.userAgent) || [])[1];
		},
		// For our regex to test for IE including IE11. Notice the user agent has changed
		IS: function () {
			return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName == 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) !== null)));
		}
	});
}());
